import {
  Box,
  ButtonBase,
  CardContent,
  CardHeader,
  Collapse,
  Icon,
  Typography,
} from "@mui/material";
import FelixCard from "../../../util/ui/felixCard";
import { IconChevronRight, IconPigMoney } from "@tabler/icons-react";
import Imposto from "../../../../models/imposto";
import { useState } from "react";
import MoedaText from "../../../util/ui/inputs/moedaText";
import moment from "moment";
import Patrimonio from "../../../../models/analises/patrimonio";
import { filter, map, some } from "lodash";
import { ClasseAtivo } from "../../../../models/enum";

type Props = {
  imposto?: Imposto;
  patrimonio?: Patrimonio[];
};

export default function Oportunidades({ imposto, patrimonio }: Props) {
  let oportunidades: JSX.Element[] = [];
  if (
    !!imposto?.darf &&
    some(
      patrimonio,
      (p) =>
        p.classeAtivo === ClasseAtivo.ACAO && p.saldoBruto > p.valorAplicado
    )
  ) {
    oportunidades.push(
      <OportunidadeIsencao imposto={imposto} patrimonio={patrimonio} />
    );
  }
  return (
    <FelixCard>
      <CardHeader
        title="Central de Oportunidades"
        avatar={<IconPigMoney size={16} />}
      />
      <CardContent>{map(oportunidades)}</CardContent>
    </FelixCard>
  );
}

function OportunidadeIsencao({ imposto, patrimonio }: Props) {
  if (!!!imposto?.darf) return <></>;
  const possibilidadeDeEconomia =
    (20000 - imposto.darf.operacoesComuns.valorVendidoIsentavel) * 0.15;
  return (
    <Oportunidade
      titulo={
        <Typography
          variant="body1"
          fontWeight={600}
          color="textPrimary"
          gutterBottom
          component="span"
        >
          Economize até <MoedaText value={possibilidadeDeEconomia} /> ainda em{" "}
          {moment().format("MMMM [de] YYYY")}
        </Typography>
      }
      subtitulo={
        <Typography variant="body2" color="textSecondary" component="span">
          Analisando seus cálculos, identificamos uma oportunidade para
          economizar até{" "}
          <b>
            <MoedaText value={possibilidadeDeEconomia} />
          </b>{" "}
          em IR ainda neste mês.
        </Typography>
      }
      mensagem={
        <Typography variant="body2" color="textSecondary" component="span">
          <p />
          Neste mês, você ainda quase não usou da isenção, vendendo apenas{" "}
          <b>
            <MoedaText
              value={imposto.darf.operacoesComuns.valorVendidoIsentavel}
            />
          </b>{" "}
          em Ações até agora no mês.
          <p />
          Para aproveitar essa oportunidade de economia fiscal, você pode vender
          até{" "}
          <b>
            <MoedaText
              value={20000 - imposto.darf.operacoesComuns.valorVendidoIsentavel}
            />
          </b>{" "}
          no total de algum de seus ativos em lucro abaixo:
          <ul>
            {map(
              filter(
                patrimonio,
                (p) =>
                  p.classeAtivo === ClasseAtivo.ACAO &&
                  p.saldoBruto > p.valorAplicado
              ),
              (p) => (
                <li>
                  <b>{p.codigoAtivo}</b>
                </li>
              )
            )}
          </ul>
          <p />
          Se desejar manter a posição depois de aproveitar essa oportunidade de
          economia fiscal, basta recomprar no dia seguinte.
        </Typography>
      }
    />
  );
}

type OportunidadeProps = {
  titulo: JSX.Element;
  subtitulo: JSX.Element;
  mensagem: JSX.Element;
};
function Oportunidade({ titulo, subtitulo, mensagem }: OportunidadeProps) {
  const [expandido, setExpandido] = useState(false);
  return (
    <Box display="flex" flexDirection="row" alignItems="flex-start" gap={1}>
      <ButtonBase
        disableRipple
        onClick={() => setExpandido((prev) => !prev)}
        sx={{ borderRadius: "50%" }}
      >
        <Icon
          fontSize="inherit"
          sx={(theme) => ({
            // Ícone em accent usa a TINTA (accentInk), nunca o preenchimento:
            // `primary.main` dá 2,57:1 sobre superfície escura.
            color: theme.palette.accentInk,
            transition: theme.transitions.create("transform", {
              duration: theme.transitions.duration.shortest,
            }),
            transform: expandido ? "rotate(90deg)" : "",
            width: 24,
            height: 24,
          })}
        >
          <IconChevronRight strokeWidth={3} />
        </Icon>
      </ButtonBase>
      <Box>
        {titulo}
        <Box py={2}>
          {subtitulo}
          <Collapse in={expandido}>{mensagem}</Collapse>
        </Box>
      </Box>
    </Box>
  );
}
